import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import inputBorder from '../hoc/inputBorder';
import { tagClass } from './styles';

var TagInput =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TagInput, _PureComponent);

  var _super = _createSuper2(TagInput);

  function TagInput(props) {
    var _this;

    _classCallCheck(this, TagInput);

    _this = _super.call(this, props);
    _this.element = void 0;
    _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TagInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(TagInput.prototype), "componentDidMount", this).call(this);

      if (this.element) this.element.focus();
    }
  }, {
    key: "bindRef",
    value: function bindRef(el) {
      this.element = el;
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var value = e.target.value;
      var onChange = this.props.onChange;
      if (onChange) onChange(value);
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      var _this$props = this.props,
          onBlur = _this$props.onBlur,
          onKeyUp = _this$props.onKeyUp,
          onEnterPress = _this$props.onEnterPress;

      if (e.keyCode === 13) {
        if (onEnterPress) onEnterPress(e.target.value, e);else if (onBlur) onBlur(e.target.value, e);
      }

      if (onKeyUp) onKeyUp(e);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var onBlur = this.props.onBlur;
      if (onBlur) onBlur(e.target.value, e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          onFocus = _this$props2.onFocus;
      return (
        /*#__PURE__*/
        React.createElement("input", {
          ref: this.bindRef,
          type: "text",
          value: value,
          onFocus: onFocus,
          onChange: this.handleChange,
          onKeyUp: this.handleKeyUp,
          onBlur: this.handleBlur
        })
      );
    }
  }]);

  return TagInput;
}(PureComponent);

export default inputBorder({
  className: tagClass('input')
})(TagInput);